import React, { ChangeEvent, FocusEvent } from 'react';
import RedStar from './RedStar';

type Props = {
    value: string | number;
    name: string;
    handleChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    handleBlur: (event: FocusEvent<HTMLTextAreaElement>) => void;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    rows?: number;
    placeholder?: string;
    style?: React.CSSProperties;
    styleLabel?: React.CSSProperties;
    errorMsg?: string;
};

const InputTextArea = ({
    value,
    name,
    handleChange,
    handleBlur,
    label = '',
    required = false,
    disabled = false,
    rows = 3,
    placeholder = '',
    style = {},
    styleLabel = {},
    errorMsg = '',
}: Props) => {

    let classes = 'form-control';
    const hasError = errorMsg ? true : false;

    if (hasError) {
        classes += ' is-invalid';
    }

    return (
        <>
            {required ? <RedStar /> : ''}
            {label ? <label className="form-label" style={styleLabel} htmlFor={`${name}Id`}>{label}</label> : ''}
            <textarea
                style={style}
                placeholder={placeholder}
                className={classes}
                rows={rows}
                disabled={disabled}
                value={value}
                required={required}
                name={name}
                id={`${name}Id`}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            {hasError ? <div id='asas' className="invalid-feedback"> {errorMsg} </div> : ''}
        </>
    );
}

export default InputTextArea;